export default __webpack_public_path__ + "static/media/slider.837c0fa4.svg";